<article *ngIf="example"
         class="link-example-popup"
         (click)="onVoid($event)">

  <button type="button"
          class="close-btn"
          aria-label="예문 팝업 닫기"
          (click)="onClose($event)"></button>

  <div class="popup-head-box">
    <app-example-disp *ngIf="exampleSJ"
                      [exampleSJ]="exampleSJ"
                      [small]="true"></app-example-disp>

    <div class="popup-option-box">
      <app-example-play-btn [example]="example"></app-example-play-btn>
    </div>
  </div>

  <div class="popup-link-box">
    <a class="popup-link-btn"
       (click)="onClickDetail($event)">
      <span class="txt more">문장 듣기에서 예문 보기</span>
      <span class="txt">자세히 보기</span>
      <i class="ic ic-link"></i>
    </a>
  </div>
</article>
